<template>
  <div class="aspect-video w-full">
    <div id="map" class="h-full w-full" />
  </div>
</template>

<script setup>
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'

const props = defineProps({
  locations: {
    type: Array,
    default: () => [],
  },
})

const config = useRuntimeConfig()

let map = null

// https://account.mapbox.com/
mapboxgl.accessToken = config.public.MAPBOX_ACCESS_TOKEN
// FUNCTIONS
// https://studio.mapbox.com/
function createMapInstance() {
  map = new mapboxgl.Map({
    container: 'map', // container ID
    style: 'mapbox://styles/novu-bern/clrhsv4qj00kc01pe9efv3rba',
    center: [7.436948828622813, 30], // starting position [lng, lat]
    zoom: 1.5, // starting zoom
  })

  map.addControl(new mapboxgl.NavigationControl())
}

function createLocationMarkers() {
  props.locations.forEach((location) => {
    if (!location.longitude || !location.latitude) return

    const position = [
      parseStringToFloat(location.longitude),
      parseStringToFloat(location.latitude),
    ]

    // Create a HTML element for the popup content
    let popupContent = document.createElement('div')

    // Create first <p> element with title and country code
    let p1 = document.createElement('p')
    // p1.innerText = `${location.title} ${location.country_code}`
    p1.innerText = location.title
    popupContent.appendChild(p1)

    // Create second <p> element with custom text
    // var p2 = document.createElement('p')
    // p2.innerText = 'Your custom text'
    // popupContent.appendChild(p2)

    // Create a Popup
    var popup = new maplibregl.Popup({
      offset: 5,
      className: 'maplibregl-popup',
    }).setDOMContent(popupContent)

    // Create the Marker
    let markerElement = document.createElement('div')
    let marker = new maplibregl.Marker({
      element: markerElement,
      color: '#0D73FF',
      anchor: 'center',
    })
      .setLngLat(position)
      .setPopup(popup) // Set the Popup on the Marker
      .addTo(map)

    // Add mouseenter and mouseleave events on the Marker's element
    markerElement.addEventListener('mouseenter', () => marker.togglePopup())
    markerElement.addEventListener('mouseleave', () => marker.togglePopup())
    markerElement.addEventListener('click', () => marker.togglePopup()) // Toggle Popup on click
  })
}

function parseStringToFloat(string) {
  string = string.replace(',', '.')
  return parseFloat(string)
}

function focusLocation(location) {
  if (!location.longitude || !location.latitude) return

  scrollMapIntoView()
  const position = [
    parseStringToFloat(location.longitude),
    parseStringToFloat(location.latitude),
  ]

  map.flyTo({
    center: position,
    zoom: 6,
    essential: true,
  })
}

function scrollMapIntoView() {
  const mapElement = document.getElementById('map')
  if (!mapElement) return
  const y = mapElement.getBoundingClientRect().top + window.scrollY - 100
  window.scrollTo({ top: y, behavior: 'smooth' })
}

onMounted(async () => {
  if (!mapboxgl) {
    console.error('Mapbox is not available')
    return
  }
  createMapInstance()
  createLocationMarkers()
})

defineExpose({
  focusLocation,
})
</script>

<style lang="scss">
.mapboxgl-canvas {
  @apply rounded-xl;
  @screen sm {
    @apply rounded-[1.25rem];
  }
}
.maplibregl-marker {
  @apply w-2 aspect-square rounded-full bg-main-blue;
}
.maplibregl-popup-content {
  @apply text-sm py-2 px-4 text-center text-white rounded-xl bg-main-blue-dark font-sans-heavy;
}
.maplibregl-popup-anchor-bottom {
  .maplibregl-popup-tip {
    @apply border-t-main-blue-dark;
  }
}
.maplibregl-popup-close-button {
  display: none;
}
</style>
